import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { UserContext } from "./UserContext";
import { appConfig } from "../../../configuration/AppConfig";

const PrivateRoute = ({ component: Component, role, ...rest }) => {
  const { user } = useContext(UserContext);

  if (!role && !sessionStorage.auth) {
    sessionStorage.setItem("route", window.location.pathname);
    sessionStorage.setItem("auth", "false");
    window.location.assign(`${appConfig.authEndpoint}${appConfig.authParams}`);
    return <span>Checking User ...</span>;
  }
  return (
    <Route
      {...rest}
      render={(props) =>
        user && role ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/not-authorized", state: { from: props.location } }} />
        )
      }
    />
  );
};

export default PrivateRoute;
